import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Grid2, IconButton, InputAdornment, Typography } from "@mui/material"
// import { Autocomplete, CurrencyInput, Input, Loader, Modal, NumericInput } from "../../../"
import { useFormik } from "formik"
import { Add, ExpandMore } from "@mui/icons-material"
// import { useMilespayAPI, useToggle } from "../../../hooks"
// import { AddCustomerModal } from "../AddCustomerModal"
import { company_customer, company_gateway, GATEWAY_PROVIDER } from '@milespay.co/db'
import { GATEWAY_PROVIDER_OPTIONS } from '@milespay.co/utils'
import { enqueueSnackbar } from "notistack"
import { CieloCredentialsSchema, CreateOrderSchema, PagarMeCredentialsSchema } from "@milespay.co/validations"
import { useMilespayAPI, useToggle } from "../../hooks"
import { Modal } from "../Modal"
import { Input } from "../Input"
import { useEffect } from "react"

interface CreateOrderModalProps {
    onClose: () => void
    onSuccess: () => void
}

export const GatewaysModal = ({ onClose, onSuccess }: CreateOrderModalProps) => {
    const [loading, loadingControls] = useToggle(false)

    const [companyGateways, companyGatewaysControls] = useMilespayAPI({
        url: '/company-gateway'
    })

    const [upsertGateway, upsertGatewayControls] = useMilespayAPI({
        url: '/company-gateway',
        method: 'PUT'
    }, {
        manual: true
    })

    const pagarmeFormik = useFormik({
        initialValues: {
            api_key: '',
        },
        validationSchema: PagarMeCredentialsSchema,
        onSubmit: async (values) => {
            await upsertGatewayControls({
                url: `/company-gateway/${GATEWAY_PROVIDER.PAGAR_ME}`,
                data: {
                    ...values
                }
            })
        }
    })

    const cieloFormik = useFormik({
        initialValues: {
            merchant_ec: '',
            merchant_id: '',
            merchant_key: '',
            merchant_name: '',
            merchant_mcc: '',
            client_id: '',
            client_secret: '',
        },
        validationSchema: CieloCredentialsSchema,
        onSubmit: async (values, formHelpers) => {
            console.log(values, formHelpers)
            const cielo = (companyGateways.data || []).find((item: company_gateway) => item.gateway_provider === GATEWAY_PROVIDER.CIELO)

            const body = Object.entries(values).reduce((prev, curr) => {
                const [key, val] = curr
                
                return {
                    ...prev,
                    ...(cielo?.id && val === cielo.id ? {} : {[key]: val})
                }
            }, {})

            await upsertGatewayControls({
                url: `/company-gateway/${GATEWAY_PROVIDER.CIELO}`,
                data: {
                    ...body
                }
            })
        }
    })

    useEffect(() => {
        if (companyGateways.data) {
            const pagarme = (companyGateways.data || []).find((item: company_gateway) => item.gateway_provider === GATEWAY_PROVIDER.PAGAR_ME)
            const cielo = (companyGateways.data || []).find((item: company_gateway) => item.gateway_provider === GATEWAY_PROVIDER.CIELO)
            
            if (pagarme) {
                pagarmeFormik.resetForm({
                    values: {
                        api_key: pagarme.id
                    }
                })
            }

            if (cielo) {
                cieloFormik.resetForm({
                    values: {
                        merchant_ec: cielo.id,
                        merchant_key: cielo.id,
                        merchant_id: cielo.id,
                        merchant_name: cielo.id,
                        merchant_mcc: cielo.id,
                        client_id: cielo.id,
                        client_secret: cielo.id,
                    }
                })
            }
        }
    }, [companyGateways])

    const handleSubmit = async () => {
        loadingControls.setTrue()
        
        if (pagarmeFormik.dirty) {
            await pagarmeFormik.submitForm()
        }
        
        if (cieloFormik.dirty) {
            await cieloFormik.submitForm()
        }
        
        enqueueSnackbar('Gateways atualizados!', {variant: 'success'})

        onSuccess()

        loadingControls.setFalse()
    }
    
    return (
        <>
            <Modal
                title="Configurar Gateways"
                open
                onClose={loading ? undefined : onClose}
                bodyCustomCss={{
                    width: 500
                }}
                onConfirm={loading ? undefined : handleSubmit}
                confirmLabel="Confirmar"
            >
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="cielo-content"
                        id="cielo-header"
                    >
                        <Typography component="span" color={!cieloFormik.errors.merchant_id || !cieloFormik.errors.merchant_key ? 'success' : 'error'}>
                            {GATEWAY_PROVIDER_OPTIONS.find(item => item.value === GATEWAY_PROVIDER.CIELO)?.label}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box display={"flex"} gap={1} flexDirection={"column"}>
                            <Input
                                label="Merchant EC"
                                name="merchant_ec"
                                type="password"
                                onClick={() => {
                                    if (!cieloFormik.dirty) {
                                        cieloFormik.setFieldValue('merchant_ec', '')
                                    }
                                }}
                                onChange={cieloFormik.handleChange}
                                onBlur={cieloFormik.handleBlur}
                                error={!!cieloFormik.touched.merchant_ec && !!cieloFormik.errors.merchant_ec}
                                helperText={cieloFormik.touched.merchant_ec && cieloFormik.errors.merchant_ec}
                                value={cieloFormik.values.merchant_ec}
                            />
                            <Input
                                label="Merchant ID"
                                name="merchant_id"
                                type="password"
                                onClick={() => {
                                    if (!cieloFormik.dirty) {
                                        cieloFormik.setFieldValue('merchant_id', '')
                                    }
                                }}
                                onChange={cieloFormik.handleChange}
                                onBlur={cieloFormik.handleBlur}
                                error={!!cieloFormik.touched.merchant_id && !!cieloFormik.errors.merchant_id}
                                helperText={cieloFormik.touched.merchant_id && cieloFormik.errors.merchant_id}
                                value={cieloFormik.values.merchant_id}
                            />
                            <Input
                                label="Merchant Key"
                                name="merchant_key"
                                type="password"
                                onClick={() => {
                                    if (!cieloFormik.dirty) {
                                        cieloFormik.setFieldValue('merchant_key', '')
                                    }
                                }}
                                onChange={cieloFormik.handleChange}
                                onBlur={cieloFormik.handleBlur}
                                error={!!cieloFormik.touched.merchant_key && !!cieloFormik.errors.merchant_key}
                                helperText={cieloFormik.touched.merchant_key && cieloFormik.errors.merchant_key}
                                value={cieloFormik.values.merchant_key}
                            />
                            <Input
                                label="MCC"
                                name="merchant_mcc"
                                type="password"
                                onClick={() => {
                                    if (!cieloFormik.dirty) {
                                        cieloFormik.setFieldValue('merchant_mcc', '')
                                    }
                                }}
                                onChange={cieloFormik.handleChange}
                                onBlur={cieloFormik.handleBlur}
                                error={!!cieloFormik.touched.merchant_mcc && !!cieloFormik.errors.merchant_mcc}
                                helperText={cieloFormik.touched.merchant_mcc && cieloFormik.errors.merchant_mcc}
                                value={cieloFormik.values.merchant_mcc}
                            />
                            <Input
                                label="Merchant Name"
                                name="merchant_name"
                                type="password"
                                onClick={() => {
                                    if (!cieloFormik.dirty) {
                                        cieloFormik.setFieldValue('merchant_name', '')
                                    }
                                }}
                                onChange={cieloFormik.handleChange}
                                onBlur={cieloFormik.handleBlur}
                                error={!!cieloFormik.touched.merchant_name && !!cieloFormik.errors.merchant_name}
                                helperText={cieloFormik.touched.merchant_name && cieloFormik.errors.merchant_name}
                                value={cieloFormik.values.merchant_name}
                            />
                            <Input
                                label="Client ID"
                                name="client_id"
                                type="password"
                                onClick={() => {
                                    if (!cieloFormik.dirty) {
                                        cieloFormik.setFieldValue('client_id', '')
                                    }
                                }}
                                onChange={cieloFormik.handleChange}
                                onBlur={cieloFormik.handleBlur}
                                error={!!cieloFormik.touched.client_id && !!cieloFormik.errors.client_id}
                                helperText={cieloFormik.touched.client_id && cieloFormik.errors.client_id}
                                value={cieloFormik.values.client_id}
                            />
                            <Input
                                label="Client Secret"
                                name="client_secret"
                                type="password"
                                onClick={() => {
                                    if (!cieloFormik.dirty) {
                                        cieloFormik.setFieldValue('client_secret', '')
                                    }
                                }}
                                onChange={cieloFormik.handleChange}
                                onBlur={cieloFormik.handleBlur}
                                error={!!cieloFormik.touched.client_secret && !!cieloFormik.errors.client_secret}
                                helperText={cieloFormik.touched.client_secret && cieloFormik.errors.client_secret}
                                value={cieloFormik.values.client_secret}
                            />
                        </Box>
                    </AccordionDetails>
                </Accordion>
                {/* <Box>
                    {createOrder.loading ? (
                        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Loader />
                        </Box>
                    ) : (
                        <Grid2 container spacing={1}>
                        <Grid2 size={{xs: 12}}>
                            <Input 
                                label="Cliente"
                                name="company_customer_id"
                                slotProps={{
                                    input: {
                                        startAdornment: <InputAdornment position="end">
                                        <IconButton
                                        onClick={addCustomerModalVisibilityControls.setTrue}
                                        edge="start"
                                        >
                                        <Add />
                                        </IconButton>
                                    </InputAdornment>
                                    }
                                }}
                                options={companyCustomerOptions}
                                select
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={!!formik.touched.company_customer_id && !!formik.errors.company_customer_id}
                                helperText={formik.touched.company_customer_id && formik.errors.company_customer_id}
                                value={formik.values.company_customer_id}
                            />
                        </Grid2>
                        <Grid2 size={{xs: 12}}>
                            <CurrencyInput 
                                label="Valor (R$)"
                                onChangeValue={(_, originaValue) => {
                                    formik.setFieldValue('price', originaValue)
                                }}
                                onBlur={formik.handleBlur}
                                value={formik.values.price}
                                error={!!formik.touched.price && !!formik.errors.price}
                                helperText={formik.touched.price && formik.errors.price}
                            />
                        </Grid2>
                        <Grid2 size={{xs: 12}}>
                            <Input 
                                label="Gateway"
                                name="company_gateway_id"
                                options={companyGatewayOptions}
                                select
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={!!formik.touched.company_gateway_id && !!formik.errors.company_gateway_id}
                                helperText={formik.touched.company_gateway_id && formik.errors.company_gateway_id}
                                value={formik.values.company_gateway_id}
                            />
                        </Grid2>
                    </Grid2>
                    )}
                </Box> */}
            </Modal>
        </>
    )
}